export default __webpack_public_path__ + "static/media/timebgyellow.425630e3.svg";